import { render, staticRenderFns } from "./FinancePayoutsBulkCreation.vue?vue&type=template&id=20971ade&"
import script from "./FinancePayoutsBulkCreation.vue?vue&type=script&lang=js&"
export * from "./FinancePayoutsBulkCreation.vue?vue&type=script&lang=js&"
import style0 from "./FinancePayoutsBulkCreation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports